var link_viewer_default = {
  "fontElementMap": "VXWBe",
  "link": "PbPPo",
  "linkInEditor": "IXCV1",
  "linkInViewer": "Cxlbs",
  "toolbarUrlContainer": "EDjzh",
  "toolbarUrl": "d2Km8",
  "toolbarUrlAnchor": "IX38y"
};
export {
  link_viewer_default as default
};
//# sourceMappingURL=link-viewer-scss.js.map
